import { message } from 'antd';
import { packageCreate } from 'global/Models/omOrderModel';

export const isPackageCompelete = (order: packageCreate, index: number, isLocker: boolean) => {
  if (isLocker && !order.lockerInfo) {
    message.error('برای سفارش ردیف ' + (index + 1) + ' اطلاعات لاکر تعیین نشده');
    return false;
  }
  if (order.package.length === 0 || !order.package) {
    message.error('برای سفارش ردیف ' + (index + 1) + ' بسته ارسالی انتخاب نشده');
    return false;
  }
  if (!order.senderClient) {
    message.error('برای سفارش ردیف ' + (index + 1) + ' فرد فرستنده تعیین نشده');
    return false;
  }
  if (!order.senderAddress) {
    message.error('برای سفارش ردیف ' + (index + 1) + ' محل جمع آوری تعیین نشده');
    return false;
  }
  if (!order.receiverClient) {
    message.error('برای سفارش ردیف ' + (index + 1) + ' فرد گیرنده تعیین نشده');
    return false;
  }

  if (!order.receiverAddress && !order.lockerInfo) {
    message.error('برای سفارش ردیف ' + (index + 1) + ' محل توزیع یا آدرس گیرنده تعیین نشده است');
    return false;
  }
  return true;
};
export const isAllPackagesCompelete = (packs: packageCreate[], isLocker: boolean, hasAccessLevel?: boolean) => {
  let compelete = true;
  packs.map((item, index) => {
    if (!compelete) return;
    compelete = isPackageCompelete(item, index, isLocker);
  });

  for (let i = 0; i < packs.length; i++) {
    for (let j = 0; j < packs[i].package.length; j++) {
      if (
        packs[i].package[j].count !== undefined &&
        //@ts-ignore
        packs[i].package[j].count !== '' &&
        packs[i].package[j].count == 0
      ) {
        message.error('برای سفارش ردیف ' + (i + 1) + ' بسته ردیف  ' + (j + 1) + ' تعداد تعیین نشده است');
        return false;
      }
    }
  }

  //each pack have an attay of package which have a count property
  const totalCount = packs.reduce((acc, item) => {
    return acc + item.package.reduce((acc, item) => acc + (item?.count ? +item.count : 1), 0);
  }, 0);
  if (totalCount > 25) {
    message.error('تعداد کل بسته ها نباید بیشتر از 25 باشد');
    return false;
  }

  // check number of barcodes is smae as count in each packaging
  if (hasAccessLevel) {
    for (let packIndex = 0; packIndex < packs.length; packIndex++) {
      const pack = packs[packIndex];
      for (let packagingIndex = 0; packagingIndex < pack.package.length; packagingIndex++) {
        const packaging = pack.package[packagingIndex];
        const count = packaging.count !== undefined ? +packaging.count : 1;
        const barcodes = packaging.barcodes || [];
        const barcodesLength = barcodes.length;

        // Check if barcodes array has empty string(s) or is ['']
        const hasInvalidBarcode = barcodesLength === 0 || barcodes.some((b) => !b || b.trim() === '');

        if (barcodesLength !== count || hasInvalidBarcode) {
          message.error(`برای سفارش ردیف ${packIndex + 1} بسته ردیف ${packagingIndex + 1} تعداد بارکدها با تعداد بسته ها مطابقت ندارد یا بارکد نامعتبر است`);
          compelete = false;
          break;
        }
      }
      if (!compelete) break;
    }
  }

  return compelete;
};
